import routes from './routes';

export const MODULE_NAME = 'client';
export const i18n = {
    fr: require('./i18n/fr'),
    en: require('./i18n/en'),
};
export default {
    name: MODULE_NAME,
    i18n,
    routes,
};
